module.exports = __webpack_public_path__ + "img/tab-scroll-left-arrow.357eeb00.svg";